module.exports = __webpack_public_path__ + "static/media/Lickilicky_gaussian2.43da3e99.png";